import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import {FullCalendarComponent} from "./controllers/calendars/full-calendar/full-calendar.component";
import {ToolbarComponent} from "./controllers/toolbar/toolbar.component";
import {RouterModule, Routes} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {
  FullCalendarViewComponent
} from "./controllers/calendars/full-calendar/full-calendar-view.component";
import {ConnectionService} from "./services/connection.service";
import {EmployeeService} from "./services/employee.service";
import {HttpModule} from "@angular/http";
import {TaskService} from "./services/task.service";
import {PopoverModule} from "ngx-popover";
import { SchedulerComponent } from './controllers/calendars/scheduler/scheduler.component';
import {SchedulerViewComponent} from "./controllers/calendars/scheduler/scheduler-view.component";
import {TimeplanService} from "./services/timeplan.service";
import {ResourceStatsService} from "./services/resource-stats.service";
import {EmailAccountService} from "./services/email-account.service";
import {LoginService} from "./services/login.service";
import {LoginComponent} from "./controllers/login/login.component";
import {LoginViewComponent} from "./controllers/login/login-view.component";
import {AuthGuardService} from "./auth/auth-guard.service";
import {
  MdCheckboxModule, MdRadioModule, MdSelectModule, MdSnackBarModule, MdTabsModule,
} from "@angular/material";
import {CalendarService} from "./services/calendar.service";
import {productModels} from "../environments/environment";
import {ResourceComponent} from "./controllers/resource/resource.component";
import {ResourceViewComponent} from "./controllers/resource/resource-view.component";
import {PopoverTaskComponent} from "./controllers/calendars/popover-task/popover-task.component";
import {ModalTaskComponent} from "./controllers/calendars/modal-task/modal-task.component";
import {SessionService} from "./services/session.service";
import {ConverterService} from "./services/converter.service";
import {GantChartViewComponent} from "./controllers/charts/gant-chart/gant-chart-view.component";
import {GantChartComponent} from "./controllers/charts/gant-chart/gant-chart.component";
import {JobService} from "./services/job.service";
import {ModalWarningComponent} from "./controllers/calendars/modal-warning/modal-warning.component";
import {TaskListComponent} from "./controllers/calendars/task-list/task-list.component";
import {ConfigService} from "./services/config.service";
import {SearchPipe} from "./pipes/SearchPipe";
import {SortPipe} from "./pipes/SortPipe";
import {ResponsibleCalendarComponent} from "./controllers/calendars/responsible-calendar/responsible-calendar.component";
import {ResponsibleCalendarViewComponent} from "./controllers/calendars/responsible-calendar/responsible-calendar-view.component";
import {JobConverterService} from "./services/job-converter.service";
import {SalesPersonService} from "./services/sales-person.service";
import {ModalRttComponent} from "./controllers/calendars/modal-rtt/modal-rtt.component";
import {ResourceTaskTimeService} from "./services/resource-task-time.service";
import {FileService} from "./services/file.service";
import {TaskAdministrationComponent} from "./controllers/task-administration/task-administration.component";
import {TaskAdministrationViewComponent} from "./controllers/task-administration/task-administration-view.component";
import {MyDatePickerModule} from "mydatepicker";
import {AppConfig} from "./app.config";
import { CreateTaskModalComponent } from './controllers/task-administration/CreateTaskModal/CreateTaskModal.component';
import {CustomerService} from "./services/customer.service";
import {ModalLiteTaskComponent} from "./controllers/calendars/modal-lite-task/modal-lite-task.component";
import {CommunicationLogService} from './services/communication-log.service';
import { FileHandlerViewComponent } from './controllers/file-handler/file-handler-view.component';
import {ModalNotificationComponent} from './controllers/calendars/modal-notification/modal-notification.component';
import {NotificationService} from './services/notification.service';
import {MaintenanceObjectService} from './services/maintenance-object.service';
import {EplannerTasksWithFilterService} from './services/eplanner-tasks-with-filter.service';
import {TaskActivityService} from './services/task-activity.service';
import {NotificationOverviewComponent} from './controllers/notification-overview/notification-overview.component';
import {NotificationOverviewViewComponent} from './controllers/notification-overview/notification-overview-view.component';
import {SimpleSearchPipe} from './pipes/SimpleSearchPipe';
import {ItemUsageService} from './services/item-usage.service';
import {RequisitionLineService} from './services/requisition-line.service';
import {MaintenanceObjectPickerComponent} from './controllers/calendars/maintenance-object-picker/maintenance-object-picker.component';
import {ModalItemUsageComponent} from './controllers/calendars/modal-item-usage/modal-item-usage.component';
import {ModalItemOrderComponent} from './controllers/calendars/modal-item-order/modal-item-order.component';
import { TaskOverviewComponent } from './controllers/notification-overview/task-overview/task-overview.component';
import { TaskOverviewViewComponent } from './controllers/notification-overview/task-overview/task-overview-view.component';
import { ModalExpandedTextfieldComponent } from './controllers/calendars/modal-expanded-textfield/modal-expanded-textfield.component';
import { TranslationService } from './services/translation.service';
import { TranslationPipe } from './pipes/TranslationPipe';
import { RouteService } from "./services/route.service";
import { ModalErrorComponent } from './controllers/calendars/modal-error/modal-error.component';
import { CommunicationLogViewComponent } from "./controllers/calendars/communication-log/communication-log-view.component";
import {RequestInterceptor} from "./services/Interceptors/RequestInterceptor";
import { EntraLoginManager } from "./managers/entra-login.manager";

function initConfig(config: AppConfig){
  return () => config.load()
}

const routes: Routes = [
  { path: '', component: ResponsibleCalendarComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/calendar/:id', component: FullCalendarComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/calendar/:id/:view/:date', component: FullCalendarComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/calendar', component: FullCalendarComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/scheduler', component: SchedulerComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/scheduler/:date', component: SchedulerComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/scheduler/:filler/:taskref', component: SchedulerComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/resource', component: ResourceComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/gantchart', component: GantChartComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/gantchart/:jobno', component: GantChartComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/task-administration', component: TaskAdministrationComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Lite] }},
  { path: ':language/responsibleCalendar', component: ResponsibleCalendarComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Premium] }},
  { path: ':language/login', component: LoginComponent},
  { path: ':language/login/:username/:password/:company/:jobno', component: LoginComponent},
  { path: ':language/login/:username/:password/:company', component: LoginComponent},
  { path: ':language/maintenancetasks', component: GantChartComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Maintenance] }},
  { path: ':language/notificationoverview', component: NotificationOverviewComponent, canActivate: [AuthGuardService], data: { allowedProductModels: [productModels.Maintenance] }},
  { path: ':language/taskoverview', component: TaskOverviewComponent, canActivate: [AuthGuardService],data: { allowedProductModels: [productModels.Maintenance] }}
];

@NgModule({
  declarations: [
    AppComponent,
    FullCalendarComponent,
    ToolbarComponent,
    FullCalendarViewComponent,
    SchedulerComponent,
    SchedulerViewComponent,
    LoginComponent,
    LoginViewComponent,
    ResourceComponent,
    ResourceViewComponent,
    PopoverTaskComponent,
    ModalTaskComponent,
    ModalRttComponent,
    GantChartComponent,
    GantChartViewComponent,
    ModalWarningComponent,
    TaskListComponent,
    SearchPipe,
    SimpleSearchPipe,
    SortPipe,
    TranslationPipe,
    ResponsibleCalendarComponent,
    ResponsibleCalendarViewComponent,
    TaskAdministrationComponent,
    TaskAdministrationViewComponent,
    CreateTaskModalComponent,
    ModalLiteTaskComponent,
    FileHandlerViewComponent,
    ModalNotificationComponent,
    NotificationOverviewComponent,
    NotificationOverviewViewComponent,
    MaintenanceObjectPickerComponent,
    ModalItemUsageComponent,
    ModalItemOrderComponent,
    TaskOverviewComponent,
    TaskOverviewViewComponent,
    ModalExpandedTextfieldComponent,
    ModalErrorComponent,
    CommunicationLogViewComponent
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    PopoverModule,
    MdSnackBarModule,
    MdTabsModule,
    MdSelectModule,
    MdRadioModule,
    MdCheckboxModule,
    MyDatePickerModule,

    RouterModule.forRoot(routes, {useHash: false})
  ],
  exports: [
    MdSnackBarModule,
    MdTabsModule,
    MdSelectModule,
  ],
  providers: [ConnectionService, EmployeeService, TaskService, TimeplanService, ResourceStatsService,
    EmailAccountService, LoginService, AuthGuardService, SessionService, ConverterService, JobService,
    CalendarService, ConfigService, JobConverterService, SalesPersonService,
    ResourceTaskTimeService, FileService, CustomerService, CommunicationLogService, NotificationService,
    MaintenanceObjectService, EplannerTasksWithFilterService, AppConfig, TaskActivityService, ItemUsageService, RequisitionLineService, TranslationService, RouteService,
    TranslationPipe, RequestInterceptor, EntraLoginManager,
    { provide: APP_INITIALIZER,
      useFactory(config: AppConfig){return () => config.load()},
      deps: [AppConfig],
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/app.module.ts